import { DescriptionList_Content_default } from "./chunk-GVKQOHU3.js";
import { DescriptionList_Title_default } from "./chunk-QZL2CDQH.js";
import { DescriptionList_default } from "./chunk-GGARLNXS.js";

// src/elements/DescriptionList/index.ts
var DescriptionListComponent = DescriptionList_default;
DescriptionListComponent.Title = DescriptionList_Title_default;
DescriptionListComponent.Title.displayName = "DescriptionList.Title";
DescriptionListComponent.Content = DescriptionList_Content_default;
DescriptionListComponent.Content.displayName = "DescriptionList.Content";
export { DescriptionListComponent };